import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumBubble = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.00005 0.799988C3.79721 0.799988 0.300049 3.97559 0.300049 7.99999C0.300049 12.0244 3.79721 15.2 8.00005 15.2C9.50632 15.2 10.9159 14.7951 12.107 14.0917L14.3188 14.6738C14.5596 14.7371 14.8159 14.6678 14.9919 14.4918C15.168 14.3157 15.2373 14.0594 15.1739 13.8187L14.6137 11.6899C15.302 10.613 15.7 9.35056 15.7 7.99999C15.7 3.97559 12.2029 0.799988 8.00005 0.799988ZM8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM12 8C12 8.55228 11.5523 9 11 9C10.4477 9 10 8.55228 10 8C10 7.44772 10.4477 7 11 7C11.5523 7 12 7.44772 12 8ZM5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_3543_4182)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M13.8562 11.5621L13.2846 11.1581C13.1652 11.327 13.1266 11.5402 13.1792 11.7403L13.8562 11.5621ZM11.9947 13.3383L12.1729 12.6614C11.9826 12.6113 11.78 12.6436 11.6147 12.7505L11.9947 13.3383ZM14.4969 13.9968L14.3188 14.6738C14.5595 14.7371 14.8158 14.6678 14.9919 14.4918C15.1679 14.3157 15.2372 14.0594 15.1739 13.8187L14.4969 13.9968ZM14.3 8C14.3 9.16246 13.9289 10.2465 13.2846 11.1581L14.4278 11.9662C15.2298 10.8317 15.7 9.46787 15.7 8H14.3ZM8 2.2C11.5292 2.2 14.3 4.8447 14.3 8H15.7C15.7 3.9756 12.2028 0.8 8 0.8V2.2ZM1.7 8C1.7 4.8447 4.47085 2.2 8 2.2V0.8C3.79716 0.8 0.3 3.9756 0.3 8H1.7ZM8 13.8C4.47085 13.8 1.7 11.1553 1.7 8H0.3C0.3 12.0244 3.79716 15.2 8 15.2V13.8ZM11.6147 12.7505C10.5943 13.4101 9.34912 13.8 8 13.8V15.2C9.62076 15.2 11.1295 14.7312 12.3747 13.9262L11.6147 12.7505ZM11.8166 14.0153L14.3188 14.6738L14.675 13.3199L12.1729 12.6614L11.8166 14.0153ZM15.1739 13.8187L14.5331 11.384L13.1792 11.7403L13.8199 14.175L15.1739 13.8187Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ jsx("circle", {
                            cx: "8",
                            cy: "8",
                            r: "1",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ jsx("circle", {
                            cx: "11",
                            cy: "8",
                            r: "1",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ jsx("circle", {
                            cx: "5",
                            cy: "8",
                            r: "1",
                            fill: "currentColor"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_3543_4182",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { MediumBubble as default };
